import axios from "@/utils/request"

/**
 * @method getindexdataApi 首页获取信息
 */
export function getindexdataApi(data) {
    return axios({
        url: "/api/getindexdata",
        method: "GET",
        params: data
    })
}

/**
 * @method getintroducApi 获取医院信息简介
 */
export function getintroducApi(data) {
    return axios({
        url: "/api/getintroduc",
        method: "GET",
        params: data
    })
}

/**
 * @method getdoctorApi 获取医生分页
 */
export function getdoctorApi(data) {
    return axios({
        url: "/api/getdoctor",
        method: "POST",
        data: data
    })
}

/**
 * @method getEveryonedoApi 获取医生详情
 */
export function getEveryonedoApi(data) {
    return axios({
        url: "/api/getEveryonedo",
        method: "POST",
        data: data
    })
}

/**
 * @method getmessageApi 获取文章分页
 */
export function getmessageApi(data) {
    return axios({
        url: "/api/getmessage",
        method: "POST",
        data: data
    })
}

/**
 * @method getmessdetaileApi 获取文章详情
 */
export function getmessdetaileApi(data) {
    return axios({
        url: "/api/getmessdetaile",
        method: "POST",
        data: data
    })
}